<!--
    @id        page-person-auth
    @desc      文件验签-无需登录
    @level     page：页面组件
    
    @date      2021-12-7 10:38:29
-->
<template>
  <div class="wrap">
    <el-card style="min-height:500px">
      <h2 class="text-center">文件验签</h2>
      <p class="discription" v-show="isShowUpload">检测电子文件签名是否被篡改，文件是否真实有效</p>
      <p class="discription blue-text pointer" @click="isShowUpload=true" v-show="!isShowUpload">验签下一份文件</p>
      <div class="text-center upload-dragger" v-show="isShowUpload">
        <div class="manuall-check-pic">
          <div class="_sys-verfi-upfile-box" @dragenter.stop.prevent @dragover.stop.prevent
            @drop.stop.prevent="dropFile" @click.stop="selectFile">
            <div class="_sys-verfi-upfile-uploadarea">
              <div>
                <i class="el-icon-plus plus"></i>
                <div>
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
              </div>
            </div>
            <div v-show="uploading" class="_sys-verfi-upfile-upload" :style="uploadingStyle">处理中...</div>
            <div v-if="uploaded" class="_sys-verfi-upfile-upload-end">
              <div class="notice">
                <i class="icon-complete complete"></i>
                <span>上传成功</span>
              </div>
            </div>
          </div>
        </div>
        <p style="padding-top:40px">只能上传pdf文件，且不超过50Mb</p>
      </div>

      <div class="verify-result" v-show="!isShowUpload">
        <div class="verify-result-content">
          <div class="result-content" v-if="hasVerifyResult">
            <!-- <p class="second-title">文件名称：{{verifyResData.fileName}}</p>
            <p class="second-title">文件有效性：
              <template v-if="failureSealNum">签章文档已失效，{{failureSealNum}}个章失效</template>
              <template v-else>签章文档有效</template></p> -->
            <p class="assential-information">
              <span class="second-title">签名信息</span>
              <span class="autograph-num">
                文件中共有
                <span class="red-text"> {{verifyResData.totalSignFields}}</span>个签名
              </span>
            </p>
            <div class="show-message" v-for="(item, index) in verifyResData.verifyResults" :key="index">
              <div class="horizen-layer">
                <div class="left-content">
                  <div class="contruct-body">
                    <p class="contruct-label">签章结果：</p>
                    <div class="contruct-text">
                      <!-- <span class="red-text" v-if="item.signInfo.modified"> 经验证，本次签名无效</span>
                              <span class="green-text" v-else>经验证，本次签名有效</span> -->
                      <span class="red-text" v-if="item.signInfo.modified">签名已被篡改</span>
                      <span class="warning" v-else-if="item.signInfo.certInvalid">签名存在风险</span>
                      <span class="warning" v-else-if="!item.certInfo.certAgainstRootValid">签名超出平台信任范围</span>
                      <span class="green-text" v-else>签名有效且可信</span>
                    </div>
                  </div>
                  <div class="contruct-body">
                    <p class="contruct-label">签章人：</p>
                    <div class="contruct-text">
                      <span> {{item.signInfo.signUser}} </span>
                    </div>
                  </div>
                  <div class="contruct-body" v-if="item.signInfo.signUserIDNo">
                    <p class="contruct-label">签章人标识：</p>
                    <div class="contruct-text">
                      {{ item.signInfo.signUserIDNo.substr(0, 8) + '***********' + item.signInfo.signUserIDNo.substr(item.signInfo.signUserIDNo.length-1)}}
                    </div>
                  </div>
                  <div class="contruct-body" v-if="item.certInfo.tsaResult.timeStampDate">
                    <p class="contruct-label">签名时间：</p>
                    <div class="contruct-text">{{translateTime(item.certInfo.tsaResult.timeStampDate)}}
                      <span class="green-text">(该时间为权威时间戳，经验证有效)</span>
                    </div>
                  </div>
                  <div class="contruct-body">
                    <p class="contruct-label">是否使用时间戳：</p>
                    <div class="contruct-text">
                      {{item.certInfo.tsaResult.timeStampEmbedded?'是':'否'}}
                    </div>
                  </div>
                  <template v-if="item.signInfo.signAlgorithmName">
                    <div class="contruct-body">
                      <p class="contruct-label">签名算法：</p>
                      <div class="contruct-text">
                        RSA
                      </div>
                    </div>
                    <div class="contruct-body">
                      <p class="contruct-label">签名状态：</p>
                      <div class="contruct-text">
                        {{item.signInfo.modified?'无效':'有效'}}
                      </div>
                    </div>
                  </template>
                  <!-- <template  v-if="item.containSm2"> 
                          <div class="contruct-body">
                            <p class="contruct-label">签名算法：</p>
                            <div class="contruct-text">
                                SM2
                            </div>
                          </div>
                          <div class="contruct-body">
                            <p class="contruct-label">签名状态：</p>
                            <div class="contruct-text">
                                {{item.code?'无效':'有效'}}
                            </div>
                          </div>
                        </template> -->
                </div>
                <!-- <div class="right-content" v-if="item.signInfo.signImage">
                        <h4 class="text-center">电子印章</h4>
                        <img class="img" :src="`data:image/jpeg;base64,${item.signInfo.signImage}`" alt />
                    </div> -->
              </div>
            </div>
          </div>
          <div v-else>
            <p class="text-center tip no-result">抱歉，未查询到签名信息</p>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
    selectFile,
    formatDate
} from "@commons/util.js"

import {
    fileverifyForm
} from "@interfaces/file-verify/index.js"
const FILE_MAX_SIZE = 1024 * 1024 * 50 //50M

export default {
    data() {
        return {

            file: null,
            uploading: false, //是否正在上传
            uploadPrecent: 0,
            uploaded: false,
            // 展示为上传状态
            isShowUpload: true,
            // 验证通过
            hasVerifyResult: true,
            verifyResData: {},
            // 失效章个数
            failureSealNum: 0
        }
    },
    computed: {
        uploadingStyle() {
            return {
                height: this.uploadPrecent + "%"
            }
        }
    },
    created() {},
    methods: {
        translateTime(time) {
            return formatDate(time, "YYYY-MM-dd HH:mm:ss")
        },
        dropFile(e) {
            if (this.uploading) return
            let file = e.dataTransfer.files[0]
            this.chooseFile(file)
        },
        selectFile() {
            if (this.uploading) return
            selectFile(".pdf", FILE_MAX_SIZE).then(file => {
                this.chooseFile(file)
            }).catch(err => {
                if (err.message === "ERROR_FILE_TYPE") {
                    this.$message.error("选择的文件类型错误，请选择文件图片类型.pdf")
                    // this.$emit("uploadError", "选择的文件类型错误，请选择文件图片类型.odf、.pdf")
                } else if (err.message === "ERROR_FILE_SIZE") {
                    this.$message.error("文件的大小超过限制")
                    // this.$emit("uploadError", "文件的大小超过限制")
                }
            })
        },
        computeFailureSealNum(data) {
            let signatureInfos = data.signatureInfos
            this.failureSealNum = 0
            if (signatureInfos) {
                signatureInfos.forEach((item, i) => {
                    if (item.code == 1) {
                        this.failureSealNum += 1
                    }
                })
            }
        },
        async chooseFile(file) {
            let fileName = file.name
            this.uploading = true
            fileverifyForm({
                file: file,
                onUploadProgress: e => {
                    let p = (e.loaded / e.total * 100).toFixed(2)
                    this.uploadPrecent = p
                }
            }).then(res => {
                /**
           * FILE_INTEGRAL_CERT_VALID-验证成功，有证书签名，文件完整，证书可信; 
           * FILE_INTEGRAL_USER_CERT_INVALID-验证成功，有证书签名，文件完整，用户证书无效; 
           * FILE_INTEGRAL_ROOT_CERT_UNAUTHENTIC-验证成功，有证书签名，文件完整，根证书不可信; 
           * FILE_MODIFIED-验证成功，文件已被修改; 
           * FILE_UNSIGNED-验证成功，文件未被签名; 
           * NO_CERT_VALID-验证成功，无证书签名，默认所有签名有效; 
           * FAILURE-验证失败
           */

                const {
                    data
                } = res.data
                console.log(JSON.stringify(data))
                // if(data.code==1000000){
                //   this.$message.error(data.message)
                //   return 
                // }
                this.verifyResData = data.verifier
                if (data.verifyResults && data.verifyResults.length == 0) {
                    this.hasVerifyResult = false
                } else {
                    this.hasVerifyResult = true
                }
                // 使用了 就关掉；
                this.isShowUpload = false
                this.uploaded = true
            }).catch(err => {
                this.$message.error("上传文档失败")
                this.uploading = false
            }).finally(_ => {
                this.uploading = false
                setTimeout(_ => {
                    this.uploaded = false
                }, 3000)
            })
        },
        beforeFileUpload(file) {
            const isPDF = file.type === "application/pdf"
            const isLt50M = file.size / 1024 / 1024 < 50
            if (!isPDF) {
                this.$message.error("上传文件只能是 pdf 格式!")
            }
            if (!isLt50M) {
                this.$message.error("上传文件大小不能超过 50Mb!")
            }
            return isPDF && isLt50M
        },
    },
    components: {},
}
</script>
<style>
  .upload-dragger {
    margin: 0 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
</style>
<style lang="less" scoped>
  @import "~@styles/variable.less";

  .wrap {
    overflow-x: hidden;
    height: 100%;
    .text-center {
      text-align: center;
    }

    .red-text {
      color: #d80000;
    }

    .title {
      text-align: center;
    }

    .discription {
      margin: 10px 0;
      text-align: center;
    }

    .blue-text {
      color: #FF8300;
    }

    .pointer {
      cursor: pointer;
    }

    .second-title {
      font-weight: 700;
      margin-bottom: 20px;
      font-size: 16px;
      color: #25303a;
    }

    .assential-information {
      margin: 30px 0 20px 0;
    }

    .show-message {
      background: #fcf2de;
      border: 1px solid #e5e5e5;
      border-radius: 5px;
      margin-bottom: 30px;
      padding: 30px;
    }

    .horizen-layer {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
    }

    .green-text {
      color: #67c23a;
    }

    .left-content {
      width: 600px
    }

    .contruct-body {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      margin: 10px 0 20px 0;
    }

    .contruct-label {
      width: 140px;
      text-align: left;
      color: #909399;
    }

    .contruct-text {
      -webkit-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      margin: 0;
    }

    .verify-result {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .right-content {
      position: relative;
      width: 260px;
      padding: 10px;
      height: 100%;
      text-align: center;

      .img {
        margin: 10px auto;
        width: 180px;
      }

      .tag {
        position: absolute;
        right: 6px;
        bottom: 20px;
      }
    }
  }
</style>

<style lang="less">
  @import "~@styles/variable.less";
  @prefix: _sys-verfi-upfile;

  .@{prefix}-box {
    position: relative;
    cursor: pointer;
    width: 500px;
    height: 200px;
    border-radius: 5px;
    background: @color-white;
    box-sizing: border-box;
    border: 2px dashed #ff8300;

    .@{prefix}-uploadarea {
      position: absolute;
      width: 220px;
      text-align: center;
      top: (200px - 110px) / 2;
      left: (500px - 220px) / 2;
      color: #ff8300;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .@{prefix}-upload {
      position: absolute;
      left: 0;
      right: 0;
      height: 0%;
      bottom: 0;
      background: #ff8300;
      transition: height 1s;
      color: #fff;
      font-size: 20px;
      line-height: 200px;
    }

    .@{prefix}-upload-end {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      animation: fadein 3s;

      .notice {
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        animation: fade 3s;
      }

      span {
        display: block;
        margin-top: 10px;
        color: #fff;
        font-size: @font-size-primary;
      }
    }
  }

  .plus {
    font-size: 50px;
    margin-bottom: 30px
  }

  .complete {
    color: @color-success;
    font-size: 50px;
  }

  @keyframes fadein {
    from {
      background: rgba(0, 0, 0, 0);
    }

    to {
      background: rgba(0, 0, 0, 0.5);
    }
  }

  @keyframes fade {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @media screen and (max-width:414px) {
    .show-message {
      width: 240px;
    }

    .horizen-layer {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      flex-wrap: wrap;

    }

    .contruct-label {
      width: 100px !important;
      text-align: left;
      color: #909399;

    }

    .contruct-text {
      width: 100px !important;
      display: flex;
      flex-wrap: wrap;

      span {
        width: 150px;
        word-wrap:break-word;
      }
    }

    .@{prefix}-box {
      position: relative;
      cursor: pointer;
      width: 300px;
      height: 150px;
      border-radius: 5px;
      background: @color-white;
      box-sizing: border-box;
      border: 2px dashed #ff8300;

      .@{prefix}-uploadarea {
        position: absolute;
        width: 220px;
        text-align: center;
        top: (150px - 110px) / 2;
        left: (300px - 220px) / 2;
        color: #ff8300;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .@{prefix}-upload {
        position: absolute;
        left: 0;
        right: 0;
        height: 0%;
        bottom: 0;
        background: #ff8300;
        transition: height 1s;
        color: #fff;
        font-size: 20px;
        line-height: 200px;
      }

      .@{prefix}-upload-end {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        animation: fadein 3s;

        .notice {
          text-align: center;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          animation: fade 3s;
        }

        span {
          display: block;
          margin-top: 10px;
          color: #fff;
          font-size: @font-size-primary;
        }
      }
    }

  }
   .complete {
    color: @color-success;
    font-size: 50px;
  }

  @keyframes fadein {
    from {
      background: rgba(0, 0, 0, 0);
    }

    to {
      background: rgba(0, 0, 0, 0.5);
    }
  }

  @keyframes fade {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
</style>